import FinderViewBase from '../FinderViewBase/FinderViewBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DynaFinderHome.html?raw';
//import "../AddressFinder/AddressFinderTypes";

interface DynaCfgWebRoleResult {
    code: string;
    description: string;
}

interface DynaCfgResult {
    name: string;
    description: string;
    DataApi_FunctionName: string;
    OptionsApi_FunctionName: string;
    Layout_Json: string;
    Translation_BtnContinueLabel: string;
    Translation_BtnSubmitLabel: string;

    ref_web_role: DynaCfgWebRoleResult;
}

class DynaFinderHome extends compose(FinderViewBase) {
    templateString: any = template;

    dynaCfg: "";
    tableParams: tableParams = { widgetName: "dynaTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "dyna/data?cfg=xy";
    loadFinderConfigUrl = "dyna/options?cfg=xy";
    btnContinueLabelText = "TODO: btnContinueLabelText";
    btnSubmitLabelText = "TODO: btnSubmitLabelText";

    DynaCfgJSON: string = null;
    _cfg: DynaCfgResult = null;
    headerNode: HTMLHeadingElement;

    _tableLayouts: any = [];

    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        this.getFilterlist();
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.tableParams) {
            let tableName = "default";
            if (this.hasUserRole("ActiveMusicans_extendedView")) tableName = "extended";
            this.createTable(this.tableParams.widgetName, this[this.tableParams.sContainerNodeName], /*Table Layout Name*/tableName, this._completeList);
        } else {
            alert("table params?");
        }
    }

    postCreate(): void {

        if (this.DynaCfgJSON == null) {
            this.DynaCfgJSON = (window as any).Csharp2JsBridge?.DynaCfgJSON ?? null;
        }
        if (this.DynaCfgJSON != null) {
            this._cfg = JSON.parse(this.DynaCfgJSON);

            this.loadFilterDatatUrl = "dyna/data?cfg=" + this._cfg.name;
            this.loadFinderConfigUrl = "dyna/options?cfg=" + this._cfg.name;
            this._tableLayouts = JSON.parse(this._cfg.Layout_Json);
            this._layouts = JSON.parse(this._cfg.Layout_Json);

            this.btnContinueLabelText = this.translations[this._cfg.Translation_BtnContinueLabel];
            this.btnSubmitLabelText = this.translations[this._cfg.Translation_BtnSubmitLabel];
            this.UiModder.domAttr.set(this.headerNode, "innerHTML", this._cfg.description); // mehrsprachiges Attribute wird über Locale der Session übersetzt
        }
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setDocumentTitle(this._cfg.description + " - " + this.translations["MainTitle"]);
        //this.setDocumentTitle("DynaFinder" + " - " + this.dynaCfg);
    }
}

export default mdsWidget(DynaFinderHome);